var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3Dcube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1083 4.73332L10.8833 1.91665C10.3333 1.61665 9.66666 1.61665 9.11666 1.91665L3.89166 4.73332C3.50833 4.94165 3.27499 5.34165 3.27499 5.79998C3.27499 6.24998 3.50833 6.65832 3.89166 6.86665L9.11666 9.68332C9.39166 9.83332 9.69999 9.90832 9.99999 9.90832C10.3 9.90832 10.6083 9.83332 10.8833 9.68332L16.1083 6.86665C16.4917 6.65832 16.725 6.25832 16.725 5.79998C16.725 5.34165 16.4917 4.94165 16.1083 4.73332Z",
    fill: "#909AB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25832 10.6583L3.39166 8.22492C3.01666 8.04159 2.58332 8.05825 2.23332 8.27492C1.87499 8.49992 1.66666 8.87492 1.66666 9.29158V13.8833C1.66666 14.6749 2.10832 15.3916 2.81666 15.7499L7.67499 18.1833C7.84166 18.2666 8.02499 18.3083 8.20832 18.3083C8.42499 18.3083 8.64166 18.2499 8.83332 18.1333C9.19166 17.9166 9.39999 17.5333 9.39999 17.1166V12.5249C9.40832 11.7249 8.96666 11.0083 8.25832 10.6583Z",
    fill: "#909AB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7667 8.27512C17.4083 8.05845 16.975 8.03345 16.6083 8.22512L11.75 10.6585C11.0417 11.0168 10.6 11.7251 10.6 12.5251V17.1168C10.6 17.5335 10.8083 17.9168 11.1667 18.1334C11.3583 18.2501 11.575 18.3084 11.7917 18.3084C11.975 18.3084 12.1583 18.2668 12.325 18.1834L17.1833 15.7501C17.8917 15.3918 18.3333 14.6834 18.3333 13.8835V9.29178C18.3333 8.87512 18.125 8.50012 17.7667 8.27512Z",
    fill: "#909AB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Dcube);
export default __webpack_public_path__ + "static/media/3dcube.d5c1b3641c3f092c6ccbbe5a4d86c901.svg";
export { ForwardRef as ReactComponent };